import i18next from "i18next";
import { useState } from "react";
import palette from "../../../theme/palette";
import { Title, Wrapper } from "../../home/Home.style";
import { ContainerComponent, SelectComponent } from "../../ui";

export const ScoreboardComponent = () => {
  const [airport, setAirport] = useState("9623534");
  const { t } = i18next;

  return (
    <ContainerComponent fixed style={{ width: "100%" }}>
      <Wrapper>
        <Title>{t("scoreborad")}</Title>
        <SelectComponent
          value={airport}
          options={[
            { value: "9623534", label: "Душанбе" },
            { value: "9623565", label: "Худжанд" },
            { value: "9623827", label: "Бохтар" },
            { value: "9600216", label: "Домодедово, Москва" },
            { value: "9600366", label: "Пулково, Санкт-Петербург" },
            { value: "9600421", label: "Новый аэропорт Стамбул, Стамбул" },
            { value: "9623597", label: "Дубай, ОАЭ" },
            { value: "9623598", label: "им. Индиры Ганди, Дели" },
            { value: "9600426", label: "им. Франца Йозефа Штрауса, Мюнхен, Бавария" },
            { value: "9623900", label: "Джидда, Саудовская Аравия" },
            { value: "9623556", label: "Нурсултан Назарбаев, Астана" },
            { value: "9600379", label: "Казань, Республика Татарстан" },
            { value: "9600370", label: "Кольцово, Екатеринбург" },
            { value: "9600380", label: "Курумоч, Самара" },
            { value: "9600376", label: "Красноярск" },
            { value: "9600392", label: "Алматы" },
            { value: "9623580", label: "Манас, Бишкек" },
            { value: "9600374", label: "Толмачёво, Новосибирск" },
            { value: "9600397", label: "Ташкент" },
            { value: "9850865", label: "Жуковский, Москва" },
            { value: "9623665", label: "Урумчи, Синьцзян" },
            { value: "9600447", label: "им. Имама Хомейни, Тегеран" }
          ]}
          onSelect={value => setAirport(value)}
        />
        <iframe
          title="table"
          frameborder="0"
          style={{
            "-moz-box-shadow": `0 2px 3px ${palette.shadowMd}`,
            "-webkit-box-shadow": `0 2px 3px ${palette.shadowMd}`,
            "box-shadow": `0 2px 3px ${palette.shadowMd}`,
            overflow: "hidden",
            border: 0,
            width: "100%",
            height: 642,
          }}
          src={`https://rasp.yandex.ru/informers/station/${airport}/?size=15&amp;color=1&amp;type=tablo`}
        />
      </Wrapper>
    </ContainerComponent>
  );
};
